import React from "react";
import apiUrl from "../../apiUrlConstant";
import { Scatter } from "react-chartjs-2";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { JsonToExcel } from "react-json-to-excel";
import { exceldataFormate } from "../../utils/utils";
import { Loader } from 'rsuite';  
import domtoimage from 'dom-to-image';
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};




class OverviewComponent extends React.Component {
  state = {
    data: {
      datasets : [
        {
          label: 'Scatter Chart',
          data: [
            {
              x: '2021-08-08T13:12:23',
              y: 3
            }
          ],
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          //backgroundColor: ['red','blue','black','green'],
      } 
    ]
  },
  options: {
    plugins: {
      tooltip: {
        callbacks: {
          title: function () {
            return "";
          },
          label: (tooltipItem, data) => {
            if( tooltipItem.formattedValue != "" ){
              return tooltipItem['raw']['dt'] + `, ${tooltipItem['raw']['asset_name']}, ` + "\n" + tooltipItem['raw']['tooltip']; 
            }else{
              return "NA";
            }
            
            //return tooltipItem[ tooltipItem.dataIndex ]
          }
        }
      },
      legend: { display: false },
      title: {
        display: true,
        text: "Critical Dates",
        position: "top"
      }
    },
    scales: {
      x: {
        type: 'category',
        position: 'bottom',
        title: {
          //display: true,
          text: 'Year',
        }
      },
      y: {
        type: 'category',
        position: 'left',
        labels: [ 'Invoice Signing Date', 'Commencement Date', 'Expiring Date' ],
        title: {
          display: true,
          text: '',
        },
      },
    },
  },
    companyPerformance: {
      x: [],
      
      datapoints: {
        y1: [
          74.4, 75, 76.2, 76.5, 77.1, 77.7, 78.6, 79.3, 80.2, 81, 82.1, 82.9,
          90.4,
        ],
      },
      bgcolor: {
        y1: "#4D8EEA",
      },
      legend: {
        y1: "Passing Rent",
      },
      axis: {
        x: "Quarters",
      },
    },

    xAxis: [],
    barThicknesS: 10,
    chartOtions: {},
    chartData: {
      labels: [],
      datasets: [],
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const ctx = document
      .getElementById("rentalsVacancyLineChart")
      .getContext("2d");
    let gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "rgba(113,206,250, 1)");
    gradient.addColorStop(1, "#cce9ff");
    const superClass = this;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            autoSkip: false,
            color: "black",
            font: {
              size: 10,
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "Area (sqft)",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
        },
      },
    };
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/overview-details?search=` +
        this.props.searchTerm +
        `&assetVal=${this.props.assetVal}&leaseStatus=${this.props.leaseStatus}&occupierVal=${this.props.occupierVal}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "response of data");
        var convertedData = exceldataFormate(data);
        superClass.state.data.datasets[0]["data"] = data.data;
        superClass.state.data.datasets[0]["backgroundColor"] = data.colors;
        superClass.state.options.scales["y"]["labels"] = data.labels;

        superClass.setState({
          chartOtions: options,
          //chartData: data1,
          isLoad: true,
          convertedData: convertedData,
        });

        superClass.setState({});

      });
  }

  downloadPdf = () => {
    const input = document.getElementById("criticalDatesComponent");

    domtoimage.toPng(input).then((canvas) => {
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(canvas);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(canvas, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("critical-dates.pdf");
    });
  };

  render() {
    return (
      <>
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <h4>Critical Dates</h4>
          </div>
          <div className="col-lg-6 p-0 float-right" >
            <Dropdown style={{ float: "right" }}>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                clas  sName="chartDownloadContainer"
              ></Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  Download as PDF
                </Dropdown.Item>
                {/* <Dropdown.Item>
                  <JsonToExcel
                    title="Download as Excel"
                    data={this.state.convertedData}
                    fileName="criticalDatesComponent"
                    btnClassName="graphExcelDownloadBtn"
                  />
                </Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-12 position-relative" id="criticalDatesComponent">
          {
              (this.state.data.datasets.length == 0) && 
              <Loader size="lg" content="Loading... " center />
            }
            <Scatter
              key={Math.random()}
              //id="rentalsVacancyLineChart"
              //options={this.state.chartOtions}
              //data={this.state.chartData}
              data={this.state.data}
              options={this.state.options}
            />
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(OverviewComponent);
